<template>
  <div>
    <base-select
      :title="label"
      :search_able="true"
      :search_in_front="false"
      :float-title="true"
      :loading="loadingGetBanks"
      v-model="bank_id"
      :options="allOptions"
      :errorMessage="errorMessage"
      :show-alert="alert"
      :disabled="disabled"
      icon="credit-card"
    />
  </div>

  <add-new-credit-card
    v-model:visible="visible_modal_add_credit_card"
    @updatedBank="createdNewBank"
    :bank_information="props.bankInformation"
    :for_user="!isNaN(user_id) ? user_id : null"
    :for_accounting="!isNaN(accounting_id) ? accounting_id : null"
    :for_car="!isNaN(car_id) ? car_id : null"
    @close="closeNewCreditBankModal"
  />
</template>

<script setup>
import BaseSelect from '@/components/base/select/BaseSelect.vue'
import { watch, onMounted, ref, defineProps, defineEmits, computed } from 'vue'
import { apiGetBankInformations } from '@/services/bank/BankInformation'
import AddNewCreditCard from '@/components/bank_informations/AddNewCreditCard.vue'

const uuid = Math.random().toString(36).slice(2)
const loadingGetBanks = ref(false)
const bank_id = ref(null)
const bank_informations = ref([])
const visible_modal_add_credit_card = ref(false)
const additionalOptions = ref([
  {
    value: 'new',
    label: 'افزودن حساب بانکی جدید',
  },
])

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: {
    type: [Number, String],
    default: null,
  },
  errorMessage: {
    type: String,
    default: null,
  },
  user_id: {
    type: String,
    Number,
    default: null,
  },
  accounting_id: {
    // کد حسابداری
    type: String,
    Number,
    default: null,
  },
  car_id: {
    // برای انتخاب حساب بانکی مربوط به یک ماشین خاص
    type: String,
    Number,
    default: null,
  },
  alert: {
    type: String,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: 'حساب بانکی واریز وجه',
  },
  options: {
    type: Array,
    default: () => [],
  },
})

onMounted(() => {
  // if(props.modelValue) user_id.value = props.modelValue
})

const allOptions = computed(() => {
  return [
    ...additionalOptions.value,
    ...bank_informations.value,
    ...propsOptions.value,
  ]
})

const propsOptions = computed(() => {
  return props.options.map((option) => {
    return {
      value: option.id,
      label: option.shaba_num || option.credit_card,
      label2: option.owner_name,
    }
  })
})

function createdNewBank(newBank) {
  bank_informations.value.push({
    value: newBank.id,
    label: newBank.shaba_num || newBank.credit_card,
    label2: newBank.owner_name,
  })
  bank_id.value = newBank.id
}

async function getBankInformations(params) {
  loadingGetBanks.value = true
  bank_informations.value = []
  try {
    const response = await apiGetBankInformations(uuid, {
      ...params,
      select_data: true,
    })
    if (!response) return
    bank_informations.value = response?.data?.bank_informations
  } catch (error) {
    console.log(error)
  } finally {
    loadingGetBanks.value = false
  }
}

function closeNewCreditBankModal() {
  visible_modal_add_credit_card.value = false
}

function openNewCreditBankModal() {
  visible_modal_add_credit_card.value = true
}

function refreshBankInformations(newValue) {
  bank_id.value = null

  if (newValue && isNaN(newValue) === false) {
    // is number
    getBankInformations({
      user_id: props.user_id || '',
      accounting_id: props.accounting_id || '',
      car_id: props.car_id || '',
    })
  } else {
    bank_informations.value = []
  }
}

watch(
  () => props.user_id,
  (newValue) => {
    refreshBankInformations(newValue)
  },
)

watch(
  () => props.accounting_id,
  (newValue) => {
    refreshBankInformations(newValue)
  },
)

watch(
  () => bank_id.value,
  (newValue) => {
    if (newValue === 'new') {
      openNewCreditBankModal()
      bank_id.value = null
    }
    emit('update:modelValue', newValue)
  },
)
</script>

<style scoped></style>
